import React, { useState, useEffect } from 'react';
import { vehicleService } from '../../services/vehicleService';

const VehicleInfo = () => {
  const [masters, setMasters] = useState([]);
  const [loading, setLoading] = useState(false);
  const initialForm = { modelName: '', manufacturer: '', status: '판매중', battery: '', range: '', certDate: '', remarks: '', image: '' };
  const [formData, setFormData] = useState(initialForm);

  const fetchMasters = async () => {
    setLoading(true);
    const data = await vehicleService.getVehicleModels();
    setMasters(data);
    setLoading(false);
  };

  useEffect(() => { fetchMasters(); }, []);

  const handleFile = async (e) => {
    if (e.target.files[0]) {
      const compressed = await vehicleService.compressImage(e.target.files[0]);
      setFormData({ ...formData, image: compressed });
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    if (!formData.modelName) return alert("모델명을 입력해주세요.");
    setLoading(true);
    await vehicleService.saveVehicleMaster(formData);
    alert("✅ 기초 차량 마스터가 클라우드에 등록되었습니다.");
    await fetchMasters();
    setFormData(initialForm);
  };

  const onDelete = async (id) => {
    if (window.confirm("삭제하시겠습니까?")) {
      await vehicleService.deleteVehicleMaster(id);
      await fetchMasters();
    }
  };

  const inputStyle = { width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '13px', fontWeight: 'bold', color: '#475569', marginBottom: '8px', display: 'block' };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', marginBottom: '30px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '30px' }}>🚒 신규 차량 마스터 등록 (Cloud)</h3>
        <form onSubmit={onSave}>
          <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 2.5fr 2.5fr 2.5fr', gap: '25px', marginBottom: '20px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '100%', height: '160px', border: '1px dashed #cbd5e1', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', overflow: 'hidden' }}>
                {formData.image ? <img src={formData.image} style={{ width: '100%' }} alt="car" /> : <span style={{ color: '#94a3b8', fontSize: '13px' }}>사진 추가</span>}
              </div>
              <input type="file" onChange={handleFile} style={{ fontSize: '11px', marginTop: '10px', width: '100%' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateRows: 'auto auto', gap: '20px' }}>
              <div><label style={labelStyle}>모델명</label><input style={inputStyle} value={formData.modelName} onChange={e => setFormData({ ...formData, modelName: e.target.value })} /></div>
              <div><label style={labelStyle}>배터리 용량 (kWh)</label><input style={inputStyle} value={formData.battery} onChange={e => setFormData({ ...formData, battery: e.target.value })} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateRows: 'auto auto', gap: '20px' }}>
              <div><label style={labelStyle}>제조사</label><input style={inputStyle} value={formData.manufacturer} onChange={e => setFormData({ ...formData, manufacturer: e.target.value })} /></div>
              <div><label style={labelStyle}>주행 거리 (km)</label><input style={inputStyle} value={formData.range} onChange={e => setFormData({ ...formData, range: e.target.value })} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateRows: 'auto auto', gap: '20px' }}>
              <div><label style={labelStyle}>판매 상태</label>
                <select style={inputStyle} value={formData.status} onChange={e => setFormData({ ...formData, status: e.target.value })}>
                  <option value="판매중">🟢 판매중</option><option value="단종">🔴 단종</option>
                </select>
              </div>
              <div><label style={labelStyle}>인증 일자</label><input type="date" style={inputStyle} value={formData.certDate} onChange={e => setFormData({ ...formData, certDate: e.target.value })} /></div>
            </div>
          </div>
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '15px', background: '#336799', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>
            {loading ? "등록 중..." : "새 차량 마스터 등록"}
          </button>
        </form>
      </div>
      <div style={{ background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h4>✅ 차량 마스터 데이터베이스 (Cloud 동기화됨)</h4>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '2px solid #f1f5f9', color: '#64748b' }}><th style={{ padding: '15px' }}>사진</th><th style={{ padding: '15px' }}>모델명/상태</th><th style={{ padding: '15px' }}>제원</th><th style={{ padding: '15px' }}>관리</th></tr>
          </thead>
          <tbody>
            {masters.map(m => (
              <tr key={m.id} style={{ borderBottom: '1px solid #f8fafc' }}>
                <td style={{ padding: '15px' }}>{m.image && <img src={m.image} width="60" style={{ borderRadius: '5px' }} alt="car" />}</td>
                <td style={{ padding: '15px' }}><b>{m.modelName}</b> <br /> <span style={{ fontSize: '12px', color: m.status === '판매중' ? 'green' : 'red' }}>● {m.status}</span></td>
                <td style={{ padding: '15px' }}>⚡ {m.battery} kWh / 🛣️ {m.range} km</td>
                <td style={{ padding: '15px' }}><button onClick={() => onDelete(m.id)} style={{ border: 'none', color: '#e74c3c', cursor: 'pointer', background: 'none' }}>삭제</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VehicleInfo;